export default {
  desktopLg3: 'screen and (max-width:1600px)',
  desktopLg: 'screen and (max-width:1440px)',
  desktopMini: 'screen and (max-width:1366px)',
  desktopMd: 'screen and (max-width:1280px)',
  tabletLg: 'screen and (max-width:1024px)',
  tabletSm: 'screen and (max-width:768px)',
  mobileLg: 'screen and (max-width:425px)',
  mobileMd: 'screen and (max-width:375px)',
  mobileSm: 'screen and (max-width:320px)',
};
